import styled from '@emotion/styled'
import tw from 'twin.macro'

export const Overlay = styled.div`
  ${tw`fixed inset-0 pointer-events-auto grid items-center h-full`}
  background-color: rgba(242, 242, 242, 0.5);
  z-index: 90;
`
